import { Injectable } from '@angular/core';
import '@stripe/stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionCheckoutService {
  private stripe: Stripe;

  constructor() {}

  public async setApiKey(apiKey: string) {
    this.stripe = await loadStripe(apiKey);
  }

  public redirectToCheckout(sessionId: string) {
    if (sessionId) {
      this.stripe
        .redirectToCheckout({
          sessionId: sessionId
        })
        .then(function(result) {});
    }
  }
}
